// TCustomizer: Click Outside to Close Popup
// This approach "rides on" the existing close button functionality
// Think of it like connecting a smart switch to your existing light switch

document.addEventListener('DOMContentLoaded', function() {
    
    // Function to add click-outside functionality to any visible modal
    function addClickOutsideListener() {
        // Find the currently visible TCustomizer modal
        const modal = document.querySelector('.vue-universal-modal-show.tcustomizer-dialog');
        
        if (!modal) {
            return; // No modal is currently visible
        }
        
        // Check if we've already added the listener to this modal
        if (modal.hasAttribute('data-click-outside-added')) {
            return; // Already has the functionality
        }
        
        // Find the existing close button that Tepo created
        const closeButton = modal.querySelector('.tcustomizer-dialog-close');
        const dialogPanel = modal.querySelector('.tcustomizer-dialog-inner');
        
        if (!closeButton || !dialogPanel) {
            console.warn('TCustomizer dialog controls not found');
            return;
        }

        // Mark this modal as having the click-outside functionality
        modal.setAttribute('data-click-outside-added', 'true');

        let modalObserver;

        const cleanup = function() {
            document.removeEventListener('click', outsideClickHandler, true);
            document.removeEventListener('keydown', escapeHandler);
            modalObserver?.disconnect();
            modal.removeAttribute('data-click-outside-added');
        };

        const closeModal = function() {
            if (!modal.classList.contains('vue-universal-modal-show')) {
                cleanup();
                return;
            }

            // Let Tepo own its state changes and any unsaved-option handling.
            closeButton.click();
            cleanup();
        };
        
        // Tepo's .vue-universal-modal-content fills the viewport, so the visible
        // .tcustomizer-dialog-inner is the boundary that distinguishes panel from backdrop.
        const outsideClickHandler = function(event) {
            const panelBounds = dialogPanel.getBoundingClientRect();
            const clickIsInsidePanel = dialogPanel.contains(event.target) || (
                event.clientX >= panelBounds.left &&
                event.clientX <= panelBounds.right &&
                event.clientY >= panelBounds.top &&
                event.clientY <= panelBounds.bottom
            );

            if (!clickIsInsidePanel) {
                closeModal();
            }
        };

        // Listen on document capture so floating widgets cannot swallow backdrop clicks.
        document.addEventListener('click', outsideClickHandler, true);
        
        // Also add Escape key support
        const escapeHandler = function(event) {
            if (event.key === 'Escape') {
                closeModal();
            }
        };
        
        document.addEventListener('keydown', escapeHandler);

        // Tepo may close itself through its X button; remove our listeners in that case too.
        modalObserver = new MutationObserver(function() {
            if (!document.body.contains(modal) || !modal.classList.contains('vue-universal-modal-show')) {
                cleanup();
            }
        });
        modalObserver.observe(modal, {
            attributes: true,
            attributeFilter: ['class']
        });
        
        console.log('Click-outside functionality added to TCustomizer modal');
    }
    
    // Watch for when TCustomizer modals appear
    // This is like having a motion sensor that detects when the popup shows up
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            // Check for new nodes being added
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Check if this is a TCustomizer modal or contains one
                        if (node.classList && node.classList.contains('vue-universal-modal-show')) {
                            setTimeout(addClickOutsideListener, 100); // Small delay to ensure modal is fully loaded
                        } else if (node.querySelector && node.querySelector('.vue-universal-modal-show')) {
                            setTimeout(addClickOutsideListener, 100);
                        }
                    }
                });
            }
            
            // Check for class changes (modal becoming visible)
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const target = mutation.target;
                if (target.classList.contains('vue-universal-modal-show')) {
                    setTimeout(addClickOutsideListener, 100);
                }
            }
        });
    });
    
    // Start watching the entire document for modal changes
    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
    });
    
    // Also check immediately in case a modal is already open
    setTimeout(addClickOutsideListener, 500);
    
    console.log('TCustomizer click-outside listener initialized');
});

/* 
SHOPIFY THEME INTEGRATION:

1. SAVE THIS CODE as 'tepo-overrides.js' in your theme's assets folder

2. ADD TO theme.liquid just before </body>:
   <script type="module" src="{{ 'tepo-overrides.js' | asset_url }}"></script>

3. HOW IT WORKS:
   - Waits for TCustomizer modal to appear
   - Adds click listener to the dark background area
   - When background is clicked, it triggers the existing × close button
   - Uses Tepo's own close functionality - no conflicts!

4. TESTING:
   - Click "Edit options" to open TCustomizer
   - Click on the dark area around the white popup to close
   - Press Escape key to close
   - The × button still works normally

This approach is bulletproof because it uses Tepo's existing close mechanism!
*/

/* H&O label adapter. Only exact English display labels are normalized. Do not
   replace app elements, listen for purchases, or change customization payloads. */
(function () {
  const selector = '.tcustomizer-btn--widget, .tcustomizer-dialog .tcustomizer-btn--atc';
  const labels = new Map([
    ['customize it', 'Customize'],
    ['add to cart', 'Add to bag'],
    ['adding to cart...', 'Adding…'],
    ['adding to cart…', 'Adding…'],
    ['added to cart', 'Added']
  ]);

  function normalizeButton(button) {
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const label = labels.get(node.textContent.trim().toLowerCase());
      if (label) node.textContent = label;
    }
    const label = labels.get((button.getAttribute('aria-label') || '').trim().toLowerCase());
    if (label) button.setAttribute('aria-label', label);
  }

  function normalizeWithin(node) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element) return;
    const owner = element.closest(selector);
    if (owner) normalizeButton(owner);
    element.querySelectorAll(selector).forEach(normalizeButton);
  }

  function start() {
    normalizeWithin(document.body);
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') normalizeWithin(mutation.target);
        else mutation.addedNodes.forEach(normalizeWithin);
      });
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

/* Purchase color and idle label follow the associated native product form's
   selected variant. Tepo owns busy/success/error states, options and cart data. */
(function () {
  const sourceSelector = 'buy-buttons[data-ho-product-purchase]';
  let activeFormId = null;
  let queued = false;

  function findSource(trigger) {
    const scope = trigger?.closest('.product-info, .quick-buy-drawer__info, .shopify-section');
    return scope?.querySelector(sourceSelector) ||
      document.querySelector('.product-info ' + sourceSelector);
  }

  function synchronizeIdleLabel(button, purchase) {
    if (!purchase || button.disabled || button.getAttribute('aria-busy') === 'true') return;
    const label = purchase.dataset.hoAction === 'preorder' ? purchase.dataset.hoPreorderLabel : purchase.dataset.hoAddLabel;
    if (!label) return;
    // This allow-list identifies idle display labels only. The purchase role
    // above is exclusively native variant data; never inferred from wording.
    const idleLabels = new Set(['Add to cart', 'Add to bag', 'Pre-order', purchase.dataset.hoAddLabel, purchase.dataset.hoPreorderLabel]);
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (idleLabels.has(node.textContent.trim()) && node.textContent.trim() !== label) node.textContent = label;
    }
    const ariaLabel = button.getAttribute('aria-label');
    if (idleLabels.has(ariaLabel) && ariaLabel !== label) button.setAttribute('aria-label', label);
  }

  function synchronize() {
    const sources = Array.from(document.querySelectorAll(sourceSelector));
    const source = sources.find(element => element.getAttribute('form') === activeFormId) ||
      findSource(document.querySelector('.tcustomizer-btn--widget'));
    const purchase = source?.querySelector('[data-ho-action="add"], [data-ho-action="preorder"]');
    const role = purchase?.dataset.hoAction || 'add';
    document.querySelectorAll('.tcustomizer-dialog .tcustomizer-btn--atc').forEach(button => {
      if (button.dataset.hoAction !== role) button.dataset.hoAction = role;
      synchronizeIdleLabel(button, purchase);
    });
  }

  function schedule() {
    if (queued) return;
    queued = true;
    queueMicrotask(() => { queued = false; synchronize(); });
  }

  function start() {
    document.addEventListener('click', event => {
      const trigger = event.target instanceof Element && event.target.closest('.tcustomizer-btn--widget');
      if (!trigger) return;
      activeFormId = findSource(trigger)?.getAttribute('form') || null;
      schedule();
    }, true);
    document.addEventListener('variant:change', schedule);
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-ho-action', 'aria-label', 'aria-busy', 'disabled'] });
    synchronize();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
